export const NUTRITION_PLAN_ASSIGNMENT_COMPACT_STEP_SELECT = "select";
export const NUTRITION_PLAN_ASSIGNMENT_COMPACT_STEP_REVIEW = "review";

function normalizeClientId(value) {
  return String(value ?? "").trim().toLowerCase();
}

export function getCompactAssignmentStep({
  isCompactLayout,
  currentStep,
  selectedClientIds,
}) {
  if (!isCompactLayout) {
    return NUTRITION_PLAN_ASSIGNMENT_COMPACT_STEP_SELECT;
  }

  const hasSelectedClients = Array.isArray(selectedClientIds) && selectedClientIds.length > 0;
  if (
    currentStep === NUTRITION_PLAN_ASSIGNMENT_COMPACT_STEP_REVIEW &&
    hasSelectedClients
  ) {
    return NUTRITION_PLAN_ASSIGNMENT_COMPACT_STEP_REVIEW;
  }

  return NUTRITION_PLAN_ASSIGNMENT_COMPACT_STEP_SELECT;
}

export function getCompactAssignmentReviewClientId({
  focusedClientId,
  selectedClientIds,
}) {
  const normalizedSelectedClientIds = Array.isArray(selectedClientIds)
    ? selectedClientIds.map(normalizeClientId).filter(Boolean)
    : [];
  const normalizedFocusedClientId = normalizeClientId(focusedClientId);

  if (
    normalizedFocusedClientId &&
    normalizedSelectedClientIds.includes(normalizedFocusedClientId)
  ) {
    return normalizedFocusedClientId;
  }

  return normalizedSelectedClientIds[0] ?? null;
}
